import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePlan } from './PlanContext';
import { ruta } from './paths';

export function PlanGate({ feature, plus = false, fallback = null, children }) {
    const { features, isPlus, loading } = usePlan();
    if (loading) return null;
    if (feature) return features?.[feature] ? <>{children}</> : fallback;
    if (plus) return isPlus ? <>{children}</> : fallback;
    return <>{children}</>;
}

export function PlusRoute({ children, redirectTo = '/dashboard' }) {
    const { isPlus, loading } = usePlan();
    if (loading) return null;
    return isPlus ? children : <Navigate to={ruta(redirectTo)} replace />;
}

export function NoTiendaRoute({ children, redirectTo = '/dashboard' }) {
    const { esTienda, loading } = usePlan();
    if (loading) return null;
    return esTienda ? <Navigate to={ruta(redirectTo)} replace /> : children;
}

export default PlanGate;
